export const onPhoneInputChange = ({ fieldName, setValue, formState }) => ({
  target: { value },
}) => {
  if (
    formState.submitCount > 0
    || formState.touchedFields[fieldName]
    || formState.dirtyFields[fieldName]
  ) {
    setValue(fieldName, value, {
      shouldTouch: true,
      shouldDirty: true,
      shouldValidate: true,
    });
    return;
  }
  setValue(fieldName, value);
};

export const onPhoneInputBlur = ({ setValue, fieldName }) => ({
  target: { value },
}) => {
  setValue(fieldName, value, {
    shouldValidate: true,
    shouldDirty: true,
    shouldTouch: true,
  });
};
